/**
 * MCP Write Approval Store
 *
 * Manages the state of write query approval requests from AI agents.
 * Used by useMcpUiControl hook and McpWriteApprovalDialog component.
 */

import { create } from 'zustand';
import type { McpWriteApprovalRequest } from '../../../types/mcpUiControl';

type WriteApprovalState = {
  /** Currently pending write approval request */
  pendingRequest: McpWriteApprovalRequest | null;

  /** Set a new pending request */
  setPendingRequest: (request: McpWriteApprovalRequest | null) => void;

  /** Approve the current request */
  approveRequest: (requestId: string) => void;

  /** Deny the current request */
  denyRequest: (requestId: string) => void;
};

export const useWriteApprovalStore = create<WriteApprovalState>((set, get) => ({
  pendingRequest: null,

  setPendingRequest: (request) => {
    set({ pendingRequest: request });
  },

  approveRequest: (requestId) => {
    const { pendingRequest } = get();
    if (pendingRequest && pendingRequest.requestId === requestId) {
      // Send approval response to main process
      window.electronAPI?.mcpUiControl?.sendWriteApprovalResponse(requestId, true);
      set({ pendingRequest: null });
    }
  },

  denyRequest: (requestId) => {
    const { pendingRequest } = get();
    if (pendingRequest && pendingRequest.requestId === requestId) {
      // Send denial response to main process
      window.electronAPI?.mcpUiControl?.sendWriteApprovalResponse(requestId, false);
      set({ pendingRequest: null });
    }
  },
}));
